import gapTheme from '../../themes/gapTheme';
import marvelTheme from '../../themes/marvelTheme';
import amazonTheme from '../../themes/amazonTheme';
import americanEagleTheme from '../../themes/americanEagleTheme';
import athletaTheme from '../../themes/athletaTheme';
import bananaRepublicTheme from '../../themes/bananaRepublicTheme';
import belkTheme from '../../themes/belkTheme';
import bpTheme from '../../themes/bpTheme';
import cathayTheme from '../../themes/cathayTheme';
import chevronTheme from '../../themes/chevronTheme';
import rakutenTheme from '../../themes/rakutenTheme';
import eBayCBTheme from '../../themes/eBayCBTheme';
import shopHQTheme from '../../themes/shopHQTheme';
import googleTheme from '../../themes/googleTheme';
import jcrewTheme from '../../themes/jcrewTheme';
import jcPennysTheme from '../../themes/jcPennysTheme';
import lowesTheme from '../../themes/lowesTheme';
import oldNavyTheme from '../../themes/oldNavyTheme';
import careCreditTheme from '../../themes/careCreditTheme';
import psccTheme from '../../themes/psccTheme';
import paypalTheme from '../../themes/paypalTheme';
import rewardsOfSportTheme from '../../themes/rewardsOfSportTheme';
import samsClubTheme from '../../themes/SamsClubTheme';
import tjMaxTheme from '../../themes/tjMaxTheme';
import syfMastercardTheme from '../../themes/syfMastercardTheme';
import synchronyTheme from '../../themes/synchronyTheme';
import zulilyTheme from '../../themes/zulilyTheme';
import payPalCreditTheme from '../../themes/payPalCreditTheme';
import crateAndBarrelTheme from '../../themes/crateAndBarrelTheme';
import nissanTheme from '../../themes/nissanTheme';
import atHomeTheme from '../../themes/atHomeTheme';
import infinitiTheme from '../../themes/infinitiTheme';
import oneTravelTheme from '../../themes/oneTravelTheme';
import cheapOAirTheme from '../../themes/cheapOAirTheme';
import norwegianRewardTheme from '../../themes/norwegianRewardTheme';
import harborFreightTheme from '../../themes/harborFreightTheme';
import verizonTheme from '../../themes/verizonTheme';
import walgreensTheme from '../../themes/walgreensTheme';
import venmoTheme from '../../themes/venmoTheme';
import virginTheme from '../../themes/virginTheme';
import bnplTheme from '../../themes/bnplTheme';
import hsnTheme from '../../themes/hsnTheme';
import qvcTheme from '../../themes/qvcTheme';
import defaultTheme from '../../themes/defaultTheme';
import peaksTheme from '../../themes/peaksTheme';
const tenantThemes = {
    defaultTheme: defaultTheme,
    amazonTheme: amazonTheme,
    americanEagleTheme: americanEagleTheme,
    athletaTheme: athletaTheme,
    atHomeTheme: atHomeTheme,
    bananaRepublicTheme: bananaRepublicTheme,
    belkTheme: belkTheme,
    bnplTheme: bnplTheme,
    bpTheme: bpTheme,
    cathayTheme: cathayTheme,
    chevronTheme: chevronTheme,
    cheapOAirTheme: cheapOAirTheme,
    crateAndBarrelTheme: crateAndBarrelTheme,
    eBayCBTheme: eBayCBTheme,
    gapTheme: gapTheme,
    googleTheme: googleTheme,
    harborFreightTheme: harborFreightTheme,
    hsnTheme: hsnTheme,
    infinitiTheme: infinitiTheme,
    jcrewTheme: jcrewTheme,
    jcPennysTheme: jcPennysTheme,
    lowesTheme: lowesTheme,
    marvelTheme: marvelTheme,
    nissanTheme: nissanTheme,
    norwegianRewardTheme: norwegianRewardTheme,
    oldNavyTheme: oldNavyTheme,
    oneTravelTheme: oneTravelTheme,
    paypalTheme: paypalTheme,
    payPalCreditTheme: payPalCreditTheme,
    careCreditTheme: careCreditTheme,
    psccTheme: psccTheme,
    qvcTheme: qvcTheme,
    rakutenTheme: rakutenTheme,
    rewardsOfSportTheme: rewardsOfSportTheme,
    samsClubTheme: samsClubTheme,
    shopHQTheme: shopHQTheme,
    syfMastercardTheme: syfMastercardTheme,
    synchronyTheme: synchronyTheme,
    tjMaxTheme: tjMaxTheme,
    verizonTheme: verizonTheme,
    walgreensTheme: walgreensTheme,
    venmoTheme: venmoTheme,
    virginTheme: virginTheme,
    zulilyTheme: zulilyTheme,
    peaksTheme: peaksTheme,
};
export default tenantThemes;
